<template>
  <dialogPanel  ref="refDialog"
                :dialogState="dialogState"
                @event-dialog-close="eventDialogClose"
                title="代码编译器设置"
                wth="400"
                hth="280">
    <div class="setting-body">
      <div class="setting-row clearfix">
        <span>主题色：</span>
        <select @change="changTheme">
          <option value="hc-black">黑色</option>
          <option value="vs-dark">暗黑</option>
          <option value="vs">白色</option>
        </select>
      </div>
      <div class="setting-row clearfix">
        <span>字体大小：</span>
        <select @change="changFont">
          <option value="12">12px</option>
          <option value="14">14px</option>
          <option value="16">16px</option>
          <option value="18">18px</option>
          <option value="20">20px</option>
          <option value="22">22px</option>
          <option value="24">24px</option>
        </select>
      </div>
      <div class="setting-row clearfix">
        <span>Tab 长度：</span>
        <select @change="changTab">
          <option value="2">2空格</option>
          <option value="4">4空格</option>
        </select>
      </div>
    </div>
    <div class="topic-footer">
      <span @click="settingClick">确定</span>
    </div>
  </dialogPanel>
</template>

<script>
import dialogPanel from "@/components/panel/dialogPanel";

export default {
  name: "settingDialog",
  props:{
    dialogState:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      setting:{
        themeVal: 'hc-black',
        fontVal: '12',
        tabVal: '2'
      }
    }
  },
  methods:{
    eventDialogClose: function (){
      this.$emit("event-dialog-close")
    },
    settingClick: function (){
      this.$emit('event-setting', this.setting)
      this.$refs.refDialog.dialogClose();
    },
    changTheme: function (e){
      this.setting.themeVal = e.target.value
    },
    changFont: function (e){
      this.setting.fontVal = e.target.value
    },
    changTab: function (e){
      this.setting.tabVal = e.target.value
    }
  },
  components:{
    dialogPanel
  }
}
</script>

<style scoped>
.setting-body{
  height: 180px;
  padding-top: 20px;
  box-sizing: border-box;
}
.setting-row{
  height: 50px;
  padding-left: 50px;
  line-height: 50px;
  font-size: 16px;
}
.setting-row span{
  font-weight: bold;
  display: inline-block;
  width: 100px;
}
.setting-row select{
  font-size:16px;
  height:30px;
  width: 100px;
}
.topic-footer{
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #eee;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.topic-footer span{
  display: block;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  float: right;
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  margin-right: 20px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  color: #2e7eee;
}
.topic-footer span:hover{
  background-color: #2e7eee;
  color: #fff;
}
</style>
